import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import utils_api from "../../api/utils";
import users_api from "../../api/users"
import GenericDialog from "../../components/GenericDialog";
import GenericInput from "../../components/GenericInput";
import dateUtils from "../../utils/DateUtils";
import Memberships from "../../models/Memberships";
import auth from "../../api/auth";


const ModifyAccessCodes = () => {
    const navigate = useNavigate()
    const params = useParams();

    const [accessCodeID, setAccessCodeID] = useState("")
    const [statuses, setStatuses] = useState([])
    const memberships = Memberships.memberships

    // Error Dialog
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogText, setDialogText] = useState("")
    const buttons = [{"text":"OK", "id": "1"}];
    const [redirect, setRedirect] = useState(false)
    const [validToken, setValidToken] = useState(true)

    // Form Fields
    const [token, setToken] = useState("")
    const [startDate, setStartDate] = useState()
    const [expiryDate, setExpiryDate] = useState()
    const [statusSelected, setStatusSelected] = useState()
    const [membershipLength, setMembershipLength] = useState()
    const [membershipSelected, setMembershipsSelected] = useState()
    const [membershipDiscount, setMembershipDiscount] = useState()
    const [membershipDiscountSubscriptionType, setMembershipDiscountSubscriptionType] = useState()
    const [forceStripeFlow, setForceStripeFlow] = useState(true)
    const [requireAccreditation, setRequireAccreditation] = useState(true)

    useEffect(() => {
        auth.hasSession().then((session) => {
            if (!session) window.location.assign("/logout");
        });
    }, [])

    useEffect(() => {
        if (!params.access_code_id) navigate("/access-codes");
        setAccessCodeID(params.access_code_id)
    }, [params.access_code_id]);

    useEffect(() => {
        GetStatuses()
    }, [accessCodeID]);

    const GetStatuses = () => {
        let response = utils_api.GetStatuses()
        response.then(
            response => {
                // Page items
                let data = response.data.statuses
                setStatuses(data)
                setStatusSelected(data[0])
            }
        ).catch((err) => {
            setDialogTitle("Fetching Error")
            setDialogText("There was an error fetching the statuses. Please try again")
            // setRedirect(true)
        })
    }

    const TestToken = (_token) => {
        if (!token) return
        let response = utils_api.TestToken(_token)
        response.then(
            response => {
                // Page items
                let valid = response.data.valid
                setValidToken(valid)
            }
        ).catch((err) => { console.log(err)})
    }

    useEffect(() => {
        TestToken(token)
    }, [token])

    const PostNewAccessCode = () => {
        if (!token || !startDate || !expiryDate || !statusSelected) {
            setDialogTitle("Error")
            setDialogText("Please ensure you have inputted all required fields prior to submitting")
            return
        }
        let body = {
            "token": token,
            "start_date": dateUtils.date_to_timestamp(startDate),
            "expiry_date": dateUtils.date_to_timestamp(expiryDate),
            "status": statusSelected.id,
            "require_accreditation": requireAccreditation
        }
        // Add membership if not bronze and selected:
        if (membershipSelected && membershipSelected.id !== 0) {
            body["membership_length"] = membershipLength * 86400
            body["membership_tier"] = membershipSelected.id
        } else if (membershipSelected && membershipSelected.id !== 0 && !membershipLength) {
            setDialogTitle("Error")
            setDialogText("Please ensure you have inputted a length for the membership you have added")
            return
        }

        // Add discount if inputted:
        if (membershipDiscount && membershipDiscount) {
            body["membership_discount"] = membershipDiscount
        }

        if (membershipDiscountSubscriptionType && membershipDiscountSubscriptionType) {
            body["discount_membership_type"] = membershipDiscountSubscriptionType["id"]
        }

        // Add force stripe flow
        body["force_stripe_flow"] = membershipDiscount && forceStripeFlow && forceStripeFlow
        let response = users_api.PostAccessCode(body)
        response.then(
            response => {
                setDialogTitle("Success")
                setDialogText("The access code was successfully created")
                setRedirect(true)
            }
        ).catch((err) => {
            setDialogTitle("Fetching Error")
            setDialogText("There was an error adding the following status. Please try again")
        })
    }

    const handleErrorDialogResult = (res) => {
        if(!res) return;
        if (redirect && redirect) navigate("/access-codes")
        setDialogText("")
        setDialogTitle("")
    }

    const UpdateStatus = (item) => {
        setStatusSelected(item)
    }

    return (
        <div className="page-container">
            <div className="page-title">
                New Access Code
            </div>
            <div className="form-container">
                <GenericInput label="Token" value={token} updateValue={setToken}/>
                {validToken && validToken ? null :
                    <div className="form-note error">* Invalid or Used Token</div>
                }
                <GenericInput type="date" label="Start Date" value={startDate}
                              updateValue={setStartDate}/>
                <GenericInput type="date" label="Expiry Date" value={expiryDate}
                              updateValue={setExpiryDate}/>
                <GenericInput type="dropdown" label="Status" value={statusSelected} options={statuses}
                              updateValue={UpdateStatus.bind(this)}/>
                <div className="form-note">* Active means it can be used</div>

                <div className="form-subtitle input-label">Free Membership</div>
                <GenericInput type="dropdown" label="Membership" value={membershipSelected} options={memberships}
                              updateValue={setMembershipsSelected.bind(this)}/>
                <GenericInput type="number" label="Membership Length (Days)" value={membershipLength}
                              updateValue={setMembershipLength}/>
                <div className="form-note">* If left blank a user will have a bronze Membership</div>

                <div className="form-subtitle input-label">Discounted Membership</div>
                <GenericInput type="number" label="Membership Dicount (%)" value={membershipDiscount}
                              updateValue={setMembershipDiscount}/>
                <GenericInput type="dropdown" label="Discount Membership Type" value={membershipDiscountSubscriptionType} options={memberships}
                    updateValue={setMembershipDiscountSubscriptionType.bind(this)}/>
                <GenericInput type="select" label="Force Stripe Flow" value={forceStripeFlow}
                    updateValue={setForceStripeFlow.bind(this)}/>
                <div className="form-note">* Discount required for force stripe flow. If discount membership is left
                    blank, the discount will work on all membership types. </div>

                <div className="form-subtitle input-label">Accreditation</div>
                <GenericInput type="select" label="Require Accreditation" value={requireAccreditation}
                    updateValue={setRequireAccreditation.bind(this)}/>

            </div>
            <div className="insert-new button link" onClick={() => PostNewAccessCode()}>
                Insert New Access Code
            </div>
            {dialogText && dialogText ? <GenericDialog title={dialogTitle} text={dialogText} buttons={buttons}
                                                       result={handleErrorDialogResult.bind(this)}/> : null}
        </div>
    )
}

export default ModifyAccessCodes